/** Frontend-API für das Cockpit-Overview (Jarvis-Startscreen, eine Aggregation). */

import type { InboxAction, TrustEntry } from './founder-inbox-api.js';

export interface CockpitEvent {
  id: number;
  type: string;
  stream: string;
  at: string;
}

export interface CockpitOverview {
  approvals: {
    counts: Record<string, number>;
    pendingCount: number;
    pending: InboxAction[];
  };
  signals: {
    total: number;
    routes: Record<string, number>;
  };
  events: {
    total: number;
    recent: CockpitEvent[];
    throughput: number[];
  };
  trust: TrustEntry[];
  companies: number;
  agents: number;
  generatedAt: string;
}

export async function getOverview(): Promise<CockpitOverview> {
  const res = await fetch('/api/cockpit/overview');
  if (!res.ok) {
    const body = await res.json().catch(() => ({ error: res.statusText }));
    throw new Error(body.error?.message ?? body.error ?? `Request failed: ${res.status}`);
  }
  return res.json() as Promise<CockpitOverview>;
}
